import { Separator, styled } from 'tamagui';

export const ItemSeparator = styled(Separator, {
  borderBottomWidth: '$1'
});
